/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {ConfirmModalConfigurationModel} from '../../../shared/confirm-modal/confirm-modal/models/confirm-modal-configuration.model';
import {AlertNotificationSeverity} from '../../../alert-notification-severity.model';

const applySettingsModalConfiguration: ConfirmModalConfigurationModel = {
    title: 'Bundles settings confirmation',
    primaryActionTitle: 'Apply',
    secondaryActionTitle: 'Discard',
    alertNotificationSeverity: AlertNotificationSeverity.INFORMATION,
    body: {
        manualChecks: {
            title: 'By applying this new set-up you will not be able to withdraw.',
            options: []
        }
    }
};

const inactivateSettingsModalConfiguration: ConfirmModalConfigurationModel = {
    title: 'Bundles settings inactivation',
    primaryActionTitle: 'Apply',
    secondaryActionTitle: 'Discard',
    alertNotificationSeverity: AlertNotificationSeverity.INFORMATION,
    body: {
        manualChecks: {
            title: 'By applying this new set-up you will not be able to withdraw.',
            options: []
        }
    }
};

const discardSettingsModalConfiguration: ConfirmModalConfigurationModel = {
    title: 'Discard bundles settings',
    primaryActionTitle: 'Discard Changes',
    secondaryActionTitle: 'Cancel',
    alertNotificationSeverity: AlertNotificationSeverity.INFORMATION,
    body: {
        manualChecks: {
            title: 'Be aware that:',
            options: ['The changes you performed will not be saved, are you sure you want to proceed?']
        }
    }
};

const defaultModalText = 'Be aware that those new settings will just be applied when a new period is created.';

/**
 * Variable to export configurations
 */
const bundlingSettingsModals: {
    applySettings: ConfirmModalConfigurationModel;
    deactivateSettings: ConfirmModalConfigurationModel;
    discardSettingsModalConfiguration: ConfirmModalConfigurationModel;
    defaultModalText: string;
} = {
    applySettings: applySettingsModalConfiguration,
    deactivateSettings: inactivateSettingsModalConfiguration,
    discardSettingsModalConfiguration: discardSettingsModalConfiguration,
    defaultModalText: defaultModalText
};

export default bundlingSettingsModals;
